import React from 'react';

import formatDate from 'utils/format-date';
import parseDate from 'utils/parse-date';

import useStyles from './styles';

interface Props {
    published: string;
    className?: string;
}

const Published: React.FC<Props> = ({ published, className }) => {
    const { classes, cx } = useStyles();

    const date = formatDate(parseDate(published), 'dd LLL yyyy');
    const time = formatDate(parseDate(published), 'HH:mm:ss');

    return (
        <span className={cx(classes.container, className)}>
            <span>🗓️</span>
            &nbsp;
            <span className={classes.primary} suppressHydrationWarning>
                {date}
            </span>
            &nbsp;
            <span className={classes.secondary} suppressHydrationWarning>
                {time}
            </span>
        </span>
    );
};

export default Published;
